import * as BasketUpdated from '@ori-events/basket-updated';
import * as UpdateBasketItem from '@ori-events/update-basket-item';
import * as UpdateBasketItemFailed from '@ori-events/update-basket-item-failed';
import type { Placement, UpdateBasketItemAnalyticsData } from '@ori/analytics-data';

interface UpdateBasketItemData extends UpdateBasketItem.Data, UpdateBasketItemAnalyticsData {}

interface UpdateBasketItemOptions {
  itemCode: string;
  lineNumber: number;
  placement: Placement;
  previousQuantity: number;
  quantity: number;
}

export const updateBasketItem = async ({
  itemCode,
  lineNumber,
  placement,
  previousQuantity,
  quantity,
}: UpdateBasketItemOptions) =>
  new Promise<void>((resolve, reject) => {
    const listener = ((event: BasketUpdated.Event | UpdateBasketItemFailed.Event) => {
      window.removeEventListener(BasketUpdated.Name, listener);
      window.removeEventListener(UpdateBasketItemFailed.Name, listener);

      const { detail } = event;
      if (UpdateBasketItemFailed.isUpdateBasketItemErrorResponse(detail)) {
        reject(new Error(`update-basket-item error: ${detail.message}`));
      } else {
        resolve();
      }
    }) as EventListener;

    window.addEventListener(BasketUpdated.Name, listener);
    window.addEventListener(UpdateBasketItemFailed.Name, listener);

    const eventToTrigger = new CustomEvent<UpdateBasketItemData>(UpdateBasketItem.Name, {
      detail: {
        lineNumber,
        quantity,
        previousQuantity,
        newQuantity: quantity,
        itemCode,
        placement,
      },
    });
    window.dispatchEvent(eventToTrigger);
  });
